export default __webpack_public_path__ + "static/media/notification.a6918281.png";